import React from 'react';
import Link from '../common/Link';
import { ReactComponent as ArrowLeft } from 'assets/img/arrow-left.svg';
import SimilarTractsList from './SimilarTractsList';

export default function SimilarTractsSidePanel({
  children,
  handleSimilarTractClick,
  activeTract,
  similarTracts,
  backLinkAction,
}) {
  return (
    <div data-component-name='SimilarTractsSidePanel' className='h-full'>
      <div className='flex flex-col h-full text-blue-600'>
        {backLinkAction && (
          <Link
            action={backLinkAction}
            icon={<ArrowLeft />}
            isIconLeft={true}
            color='text-blue-500/60'
          >
            <span className='text-base -translate-y-px'>back</span>
          </Link>
        )}

        <h2 className='pb-4 mt-4 text-lg font-bold'>Similar tracts</h2>

        <div className='h-full overflow-auto pb-7'>
          <div className='mt-3'>
            <SimilarTractsList
              activeTract={activeTract}
              similarTracts={similarTracts}
              handleSimilarTractClick={handleSimilarTractClick}
            />
          </div>

          <p className='font-sans text-xs text-blue-700 mt-7'>
            Similar tracts are selected using the key demographic features of each tract,
            including gender, age, race, and population.
          </p>
        </div>
      </div>
      {children}
    </div>
  );
}
